import { FC } from "react";
import { Typography, Card, CardContent, Input, Label } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { LoadingButton } from "@altimateai/lego";
import { IconPlayerPlay } from "@tabler/icons-react";

interface EvaluationSummaryProps {
  selectedTestCasesCount: number;
  selectedAgentsCount: number;
  selectedCriteriaCount: number;
  totalEvaluations: number;
  runName: string;
  setRunName: (name: string) => void;
  isLoading: boolean;
  onEvaluate: () => void;
}

export const EvaluationSummary: FC<EvaluationSummaryProps> = ({
  selectedTestCasesCount,
  selectedAgentsCount,
  selectedCriteriaCount,
  totalEvaluations,
  runName,
  setRunName,
  isLoading,
  onEvaluate,
}) => {
  return (
    <Card className="al-bg-gradient-to-r al-from-blue-50 al-to-purple-50 al-border-2 al-border-blue-200">
      <CardContent className="al-py-6">
        <Stack direction="column" gap="md">
          {/* Run Name Input */}
          <div className="al-max-w-md">
            <Label htmlFor="run-name" className="al-mb-2 al-block">
              Run Name (Optional)
            </Label>
            <Input
              id="run-name"
              placeholder="Enter a name for this evaluation run..."
              value={runName}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setRunName(e.target.value)}
              disabled={isLoading}
              className="al-w-full"
            />
            <Typography size="xs" className="al-text-gray-500 al-mt-1">
              Results will be grouped by this name in the All Results tab
            </Typography>
          </div>

          {/* Evaluation Summary and Button */}
          <Stack direction="row" justify="between" align="center">
            <div>
              <Typography size="lg" weight="medium" className="al-mb-2">
                Ready to Evaluate
              </Typography>
              <Stack direction="row" gap="md" className="al-text-sm al-text-gray-700">
                <span>
                  <strong>{selectedTestCasesCount}</strong> test case(s)
                </span>
                <span>with</span>
                <span>
                  <strong>{selectedAgentsCount}</strong> agent(s)
                </span>
              </Stack>
              <Typography size="xs" className="al-text-gray-600 al-mt-1">
                <strong>{totalEvaluations}</strong> evaluation(s) using{" "}
                <strong>{selectedCriteriaCount}</strong> criteria
              </Typography>
            </div>
            <LoadingButton
              loading={isLoading}
              onClick={onEvaluate}
              size="lg"
              disabled={
                selectedAgentsCount === 0 ||
                selectedTestCasesCount === 0 ||
                selectedCriteriaCount === 0 ||
                isLoading
              }
            >
              <IconPlayerPlay className="al-w-5 al-h-5 al-mr-2" />
              {isLoading ? "Submitting..." : "Evaluate"}
            </LoadingButton>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
